import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Query } from '../../Model/query';
import { Task } from '../../Model/task';
import { RequestService } from '../../services/requests.services';
import { QueryDialogData } from '../create.component';

@Component({
  selector: 'app-task-query',
  templateUrl: './task-query.component.html',
  styleUrls: ['./task-query.component.css']
})
export class TaskQueryComponent implements OnInit, OnDestroy {
  queries: Query[] = [];
  enableRun = false;
  queryId!: string;
  queryTaskList: Array<TaskWithCheckbox> = [];
  selectedtaskList: Array<Task> = [];
  isQueryRunning = false;
  isListloading = false;
  queriesSubscription?: Subscription;
  queryResultSubscription?: Subscription;

  constructor(private readonly service: RequestService,
    public dialogRef: MatDialogRef<TaskQueryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: QueryDialogData,
  ) { }

  ngOnDestroy(): void {
    this.queriesSubscription?.unsubscribe();
    this.queryResultSubscription?.unsubscribe();
    }

  ngOnInit(): void {
    this.getQueries();
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }

  getQueries() {
    this.isListloading = true;
    this.queriesSubscription= this.service.getQueries(this.data.project).subscribe({
      next: (response: Query[]) => {
        this.queries = response;
      },
      error: (err: any) => {
        this.isListloading = false;
        console.log(err.error);
      },
      complete: () => { this.isListloading = false; }
    });
  }
  selectQuery(id: string) {
    this.enableRun = true;
    this.queryId = id;
  }

  runQuery() {
    this.isQueryRunning = true;
    this.enableRun = false;
    this.queryTaskList = [];
    
    var url = "api/tasks";
    var queryId = this.queryId;
    var project = this.data.project;
    
    this.queryResultSubscription= this.service.getQueryResult(queryId, url, project).subscribe({
      next: (response: Task[]) => {
        this.queryTaskList = response.map(item => {
          return new TaskWithCheckbox(
            item.shortType,
            item.id,
            item.title,
            (this.data.selectedTasks.findIndex(x => x.id === item.id)) === -1 ? false : true
          );
        });
       
      },
      error: (err: any) => {
        console.log(err.error)
      },
      complete: () => {
        this.isQueryRunning = false;
        this.enableRun = true;
      }
    });  
  }

  onSelectTask(task: TaskWithCheckbox) {    
    if (task.checked) {
      this.removeItemArray(task.id);      
    } else {
      if (!this.isDuplicate(task.id)) {
        this.data.selectedTasks.push(new Task(task.shortType, task.id, task.title));
      }      
    }

    this.data.selectedTasks = this.data.selectedTasks.concat(this.selectedtaskList);
  }

  removeItemArray(taskId: number) {
    this.data.selectedTasks.forEach((value, index) => {
      if (value.id === taskId){
        this.data.selectedTasks.splice(index, 1);
      }
    });
  }

  isDuplicate(taskId: number): boolean {
    var index = this.data.selectedTasks.findIndex(x => x.id === taskId);
    return (index === -1) ? false : true;    
  }
  checkAllCheckBox(ev: any) {
    this.queryTaskList.forEach(x => x.checked = ev.target.checked)
  }
  
  isAllCheckBoxChecked() {
    return this.queryTaskList.every(p => p.checked);
  }
}

export class TaskWithCheckbox {
  constructor(
    public shortType: string,
    public id: number,
    public title: string,    
    public checked?: boolean
  ) { }
}
